import {DirectiveOptions} from 'vue'
import {isCoprolibDate} from '@/helpers/validators'
import {convertDateFromDirective} from '@/helpers'

const convertDateDirective: DirectiveOptions = {
  bind: function (el: any, binding, vNode) {
    el.val = binding.value
    el.handler = (e) => {
      const v = el.val
      if (v && v !== '' && isCoprolibDate(v)) {
        e.target.value = convertDateFromDirective(v)
        vNode.elm.dispatchEvent(new CustomEvent('input'))
      }
    }
    el.addEventListener('change', el.handler)
  },
  update(el: any, binding, vNode) {
    el.val = binding.value
  },
  unbind: function (el: any) {
    el.removeEventListener('change', el.handler)
  }
}

export default convertDateDirective
